<!-- Backdrop + Modal Container -->
<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true" *ngIf="show"
    style="background: rgba(0, 0, 0, 0.5)" (click)="close()">
    <div [ngClass]="dialogClass" (click)="$event.stopPropagation()">
        <div class="modal-content modal-styled p-1">
            <div class="modal-header d-flex justify-content-between align-items-center">
                <h5 class="modal-title fs-4 fw-semibold m-0 flex-grow-1">{{ title }}</h5>
                <button type="button" class="btn-close ms-3" aria-label="Close" (click)="close()"></button>
            </div>
            <div class="modal-body p-4">
                <ng-content></ng-content>
            </div>

            <div class="modal-footer border-0 p-4 pt-0" *ngIf="hasFooter">
                <ng-content select="[modal-footer]"></ng-content>
            </div>
        </div>
    </div>
</div>